export const fonts = ['inter', 'manrope', 'system'] as const
